module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav profile"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('md-menu', {
    attrs: {
      "md-size": "medium",
      "md-align-trigger": ""
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-avatar', [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/photo.png",
      "alt": "User profile image"
    }
  })])], 1), _vm._v(" "), _c('md-menu-content', {
    staticClass: "my-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/profile"
    }
  }, [_c('md-menu-item', [_c('md-icon', [_vm._v("account_circle")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Profile")])], 1)], 1), _vm._v(" "), _c('md-menu-item', {
    on: {
      "click": _vm.logOut
    }
  }, [_c('md-icon', [_vm._v("lock")]), _vm._v(" "), _c('span', {
    staticClass: "clr-gray"
  }, [_vm._v("Logout")])], 1)], 1)], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo admin-lgg",
    attrs: {
      "src": "/static/img/crp-images/Logo_RCP Smart App2.png",
      "alt": "Logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e9e5282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashHeader.vue
// module id = 2109
// module chunks = 1